import { render, staticRenderFns } from "./EmergencyContacts.vue?vue&type=template&id=73dc5cc5&scoped=true"
import script from "./EmergencyContacts.vue?vue&type=script&lang=js"
export * from "./EmergencyContacts.vue?vue&type=script&lang=js"
import style0 from "./EmergencyContacts.vue?vue&type=style&index=0&id=73dc5cc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dc5cc5",
  null
  
)

export default component.exports